// ui-context.js — build the UI working-set sent with each chat message.
// Pure (takes a state-like object), so it is node-unit-testable. The backend
// renders this into the volatile `# Active Context` block of AGENTS.md.

export function buildUiContext(state) {
  const ui = {};

  if (state.qteQuoteId) {
    ui.open_quote = { id: state.qteQuoteId };
    if (state.qteQuoteNumber) ui.open_quote.number = state.qteQuoteNumber;
  }

  if (state.cfgConfigId) {
    ui.open_config = { id: state.cfgConfigId };
    if (state.cfgProductName) ui.open_config.product = state.cfgProductName;
  }

  const tab = (state.workspaceTabs || []).find((t) => t.id === state.activeWorkspaceTab);
  if (tab && tab.path) ui.open_file = tab.path;

  return Object.keys(ui).length ? ui : null;
}
